function InfoIcon() {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="56" height="56" rx="28" fill="#E8EDFF" />
      <path
        d="M28 17.5C22.1758 17.5 17.5 22.2168 17.5 28C17.5 33.8242 22.1758 38.5 28 38.5C33.7832 38.5 38.5 33.8242 38.5 28C38.5 22.2168 33.7832 17.5 28 17.5ZM28 36.5312C23.2832 36.5312 19.4687 32.7168 19.4687 28C19.4687 23.3242 23.2832 19.4687 28 19.4687C32.6758 19.4687 36.5312 23.3242 36.5312 28C36.5312 32.7168 32.6758 36.5312 28 36.5312ZM29.6406 31.2812H28.9844V27.6719C28.9844 27.1387 28.5332 26.6875 28 26.6875H26.6875C26.1133 26.6875 25.7031 27.1387 25.7031 27.6719C25.7031 28.2461 26.1133 28.6562 26.6875 28.6562H27.0156V31.2812H26.3594C25.7852 31.2812 25.375 31.7324 25.375 32.2656C25.375 32.8398 25.7852 33.25 26.3594 33.25H29.6406C30.1738 33.25 30.625 32.8398 30.625 32.2656C30.625 31.7324 30.1738 31.2812 29.6406 31.2812ZM28 25.375C28.6973 25.375 29.3125 24.8008 29.3125 24.0625C29.3125 23.3652 28.6973 22.75 28 22.75C27.2617 22.75 26.6875 23.3652 26.6875 24.0625C26.6875 24.8008 27.2617 25.375 28 25.375Z"
        fill="#144DFF"
      />
    </svg>
  );
}

export default InfoIcon;